import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import {
  HEADER_FADEIN,
  HEADER_FADEOUT,
  SECTION_DURATION,
} from "../data/globalStyles"
import { Hero } from "../assets/images"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "100vh",
    width: "100vw",
    background: `url(${Hero}) no-repeat center center`,
    backgroundSize: "cover",
    animation: ({ show }) =>
      `${
        show ? `$${HEADER_FADEIN}` : `$${HEADER_FADEOUT}`
      } ${SECTION_DURATION} ease-in-out`,
  },
  intro: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "1.3rem 4rem 1.3rem 4rem",
    maxWidth: "1000px",
    backgroundColor: colors.cream,
    "@media only screen and (max-width: 720px)": {
      width: "100%",
      maxWidth: "100%",
      padding: "0 0 1.3rem 0",
    },
  },
  heading: {
    fontSize: "calc(30px + (44 - 30) * ((100vw - 300px) / (1600 - 300)))",
    fontWeight: 600,
    lineHeight: "1.5em",
    margin: "0.3rem 0 1.8rem 0",
    textAlign: "center",
    textDecoration: "underline",
    textDecorationColor: colors.orange,
  },
  subheading: {
    fontSize: "calc(15px + (25 - 15) * ((100vw - 300px) / (1600 - 300)))",
    margin: "1rem 0 -0.5rem 0",
    textAlign: "center",
    lineHeight: "1.5em",
  },
  start: {
    fontWeight: 600,
    fontSize: "calc(12px + (18 - 12) * ((100vw - 300px) / (1600 - 300)))",
    padding: ".5rem 2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    backgroundColor: colors.orange,
    border: `2px solid ${colors.orange}`,
    color: "white",
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      color: colors.orange,
      backgroundColor: `${colors.white}`,
    },
    "&:focus": {
      color: colors.orange,
      backgroundColor: `${colors.white}`,
    },
  },
  [`@keyframes ${HEADER_FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${HEADER_FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
}

const Header = ({ classes, setShow, section, onAnimationEnd }) => {
  return (
    section === "intro" && (
      <header className={classes.container} onAnimationEnd={onAnimationEnd}>
        <div className={classes.intro}>
          <h4 className={classes.subheading}>Build Your Own</h4>
          <h1 className={classes.heading}>Custom Thanksgiving Menu</h1>
          <button
            className={classes.start}
            onClick={() =>
              setShow((d) => ({
                ...d,
                intro: false,
                quiz: true,
              }))
            }>
            START
          </button>
        </div>
      </header>
    )
  )
}

export default withStyles(styles)(Header)
